import styled from '@emotion/styled';
import { ifProp } from 'styled-tools';
import { KayWood } from '~/features/brand-effects/components/KayWood/KayWood';
import { useActiveBrandEffect } from '~/features/brand-effects/hooks/useActiveBrandEffect';
import { IM100RichTextModule, M100RichTextLayout } from '~/lib/data-contract';
import { ModuleHeader } from '~/shared/components/ModuleHeader/ModuleHeader';
import { breakpoints } from '~/theme';

export type StyledM100RichTextTitleProps = Pick<IM100RichTextModule, 'layout'>;

export const StyledM100RichTextTitle = styled.p<StyledM100RichTextTitleProps>(
	({ theme }) => ({
		fontFamily: theme.fonts.headline,
		fontSize: theme.fontSizes['2xl'],
		fontWeight: theme.fontWeights.bold,
		color: theme.colors.black,
		lineHeight: theme.lineHeights.compact,
		letterSpacing: '5px',
		textTransform: 'uppercase',
		marginBottom: theme.space['6'],
	}),
	ifProp(
		({ layout }) => layout === M100RichTextLayout.split,
		({ theme }) => ({
			[breakpoints.md]: {
				fontSize: theme.fontSizes['xl'],
			},
			[breakpoints.lg]: {
				marginBottom: 0,
				fontSize: theme.fontSizes['2xl'],
			},
		}),
	),
);

export type M100RichTextTitleProps = Pick<IM100RichTextModule, 'headline' | 'brandEffect'>;

export const M100RichTextTitle = ({ headline, brandEffect }: M100RichTextTitleProps) => {
	const activeBrandEffect = useActiveBrandEffect(brandEffect);

	if (!headline) {
		return null;
	}

	return (
		<>
			{activeBrandEffect === 'kay' ? (
				<KayWood
					top={15}
					css={{ zIndex: -1 }}
				/>
			) : null}
			<ModuleHeader headline={headline} />
		</>
	);
};
